import type { SVGProps } from "react";

export function CafeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M 4.5996094,10.25 C 3.8629544,10.25 3.25,10.862916 3.25,11.599609 V 15 c 0,3.719019 3.0309699,6.75 6.75,6.75 h 2 c 3.113782,0 5.743551,-2.125674 6.517578,-5 H 19.5 c 1.786034,0 3.25,-1.463966 3.25,-3.25 0,-1.786034 -1.463966,-3.25 -3.25,-3.25 H 17.400391 17 Z M 18.75,11.75 h 0.75 c 0.97536,0 1.75,0.77464 1.75,1.75 0,0.97536 -0.77464,1.75 -1.75,1.75 H 18.742188 C 18.745257,15.166677 18.75,15.084053 18.75,15 Z"
        fill="currentColor"
      />
      <path
        d="M 18,2.75 A 0.75,0.75 0 0 0 17.25,3.5 V 4.1425781 C 17.25,5.3151909 16.315131,6.25 15.142578,6.25 14.253283,6.25 13.492846,6.581741 12.992188,7.1074219 12.491529,7.6331027 12.25,8.3214257 12.25,9 A 0.75,0.75 0 0 0 13,9.75 0.75,0.75 0 0 0 13.75,9 c 0,-0.3214247 0.114484,-0.6331035 0.328125,-0.8574219 C 14.291766,7.9182597 14.603275,7.75 15.142578,7.75 17.125822,7.75 18.75,6.1258622 18.75,4.1425781 V 3.5 A 0.75,0.75 0 0 0 18,2.75 Z"
        fill="currentColor"
      />
      <path
        d="M 14,2.25 A 0.75,0.75 0 0 0 13.25,3 V 3.5 C 13.25,4.1992532 12.699281,4.75 12,4.75 9.9377819,4.75 8.25,6.4378347 8.25,8.5 V 9 A 0.75,0.75 0 0 0 9,9.75 0.75,0.75 0 0 0 9.75,9 V 8.5 c 0,-1.2515314 0.998421,-2.25 2.25,-2.25 1.509917,0 2.75,-1.2401154 2.75,-2.75 V 3 A 0.75,0.75 0 0 0 14,2.25 Z"
        fill="currentColor"
      />
    </svg>
  );
}
